// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles-module__wrapper___1NJ7S"};